/**
 * Real screenshots, keyed by the media-slot label they belong to.
 * Slots without an entry here keep their "coming soon" placeholder.
 */
export const screenshots: Record<string, string> = {
  'The login screen':
    'https://cdn.magicpatterns.com/uploads/sv6vW8yZmgM3tWvbbw4BQw/Login-screen.png',
  'Settings → My Staff':
    'https://cdn.magicpatterns.com/uploads/w2oYCeowDzNNRF3CC2Wwnd/my-staff.png',
  'The + Add User button':
    'https://cdn.magicpatterns.com/uploads/4iatJGUS8iVmKRV3ecz3Hh/add-user.png',
  'The left-hand menu':
    'https://cdn.magicpatterns.com/uploads/jEbTFKLHZJE3nt6sgE67RC/CRM-Tabs-Basic.png',
  'Connect your calendar':
    'https://cdn.magicpatterns.com/uploads/w5VuokhvNe48EXK37zuiu7/connect-calendar-options.png',
  'Social Planner — connect accounts':
    'https://cdn.magicpatterns.com/uploads/oBvyssejfZG1sApNvg4mGZ/social-planner-logins.png',
  'AI Agents → Voice AI':
    'https://cdn.magicpatterns.com/uploads/mMaah6WuCacqgbhQ6Vx2LV/voice-ai.png',
}
